import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';


export const TitleBlock = {
    props: {
        structKey: [String, Number]
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'h1', 'RESPONSE_CODE', 'REQUEST_URL']),
        normalizedBreadcrumb() {
            const source = this.templateData
                && this.templateData.breadcrumb;

            if (!source || typeof source !== 'object') {
                return [];
            }

            const items = Object.keys(source)
                .map((key) => source[key])
                .filter((item) => item && typeof item === 'object')
                .map((item) => {
                    if (item.LINK === '/catalog/') {
                        return Object.assign({}, item, {
                            TITLE: 'Каталог оборудования'
                        });
                    }

                    return item;
                });
            const requestPath = String(
                this.REQUEST_URL || ''
            ).split('?')[0];
            const hasCatalog = items.some(
                (item) => item.LINK === '/catalog/'
            );

            if (
                requestPath.indexOf('/product/') === 0
                && !hasCatalog
            ) {
                const homeIndex = items.findIndex(
                    (item) => item.LINK === '/'
                );

                items.splice(homeIndex >= 0 ? homeIndex + 1 : 0, 0, {
                    TITLE: 'Каталог оборудования',
                    LINK: '/catalog/'
                });
            }

            return items;
        }
    },
    methods: {
      hideBlock(){
        return this.REQUEST_URL == '/' || this.RESPONSE_CODE == 404;
      }
    },
    template: `

<div v-if="this.templateData && !hideBlock() && (!this.templateData.hideH1block || this.templateData.hideH1block === false)" class="content-entry__wrapper">
    <div class="container">
        <div class="content-entry">
            <div class="content-entry__wp">
              <div v-if="this.normalizedBreadcrumb.length" class="breadcrumbs">
                <ul class="breadcrumbs__list">
                  <template v-for="brItem in this.normalizedBreadcrumb">
                    <li v-if="brItem.LINK == '/'" class="breadcrumbs__item">
                        <a :href="brItem.LINK" class="breadcrumbs__link breadcrumbs__link--main">
                          {{brItem.TITLE}}
                        </a>
                    </li>
                    <li v-else class="breadcrumbs__item">
                        <a :href="brItem.LINK" class="breadcrumbs__link">
                          <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                          {{brItem.TITLE}}
                        </a>
                    </li>
                  </template>
                </ul>
              </div>
              <h1 v-if="this.h1 && (!this.templateData.hideH1 || this.templateData.hideH1 === false)" v-html="this.h1"></h1>
            </div>
        </div>
    </div>
</div>
`
}